// ./helpers/titleFormatter.js

/**
 * Formats a given string by capitalizing the first letter of each word.
 * Replaces hyphens and underscores with spaces.
 *
 * @param {string} title - The raw page title to format.
 * @returns {string} - The formatted page title with each word capitalized.
 */
export const formatPageTitle = (title) => {
  if (!title) return "";

  return (
    title
      // Replace hyphens and underscores with spaces
      .replace(/[-_]/g, " ")
      // Split the title into words
      .split(" ")
      // Capitalize the first letter of each word and join them back
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ")
  );
};
